module.exports = __webpack_public_path__ + "static/media/motorcycle-background.a187eea8.jpg";